module.exports = __webpack_public_path__ + "static/img/wpc-bg.8d1adc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wpc-bg.png
// module id = 3t7I
// module chunks = 2